import { Avatar, Button, Skeleton, Table, notification } from "antd";
import axios from "axios";
import { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/User.context";
import { useHttp } from "../../../utils/DataHendler";
import { useMediaQuery } from "react-responsive"; // Import untuk deteksi media query

export const ProfileUser = () => {
  const { user } = useContext(UserContext);
  const [data, setData] = useState(null);
  const { getData } = useHttp();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  // Deteksi apakah perangkat adalah mobile
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // Fetch data for the user profile
  const fetchData = useCallback(async () => {
    try {
      const response = await getData("/profile", {}, true);
      setData(response.data);
    } catch (error) {
      console.error("Failed to fetch profile data:", error);
    }
  }, [getData]);

  useEffect(() => {
    if (!data) {
      fetchData();
    }
  }, [data, fetchData]);

  return (
    <div
      style={{
        display: isMobile ? "block" : "flex", // Ubah layout menjadi block untuk mobile
        justifyContent: isMobile ? "center" : "space-evenly",
        alignItems: "center",
        padding: isMobile ? "10px" : "20px",
        minHeight: "80vh",
      }}
    >
      {/* Left Section: Profile Picture and Actions */}
      <div
        style={{
          textAlign: "center",
          maxWidth: isMobile ? "100%" : "300px",
          margin: isMobile ? "0 auto 20px" : "0", // Tambahkan margin bawah untuk mobile
        }}
      >
        <h1
          style={{ fontSize: isMobile ? "20px" : "24px", marginBottom: "20px" }}
        >
          Profile
        </h1>
        <Avatar
          size={isMobile ? 120 : 150} // Ukuran avatar lebih kecil untuk mobile
          style={{
            backgroundColor: "#2C74B3",
            color: "white",
            fontSize: isMobile ? "40px" : "50px",
            margin: "auto",
          }}
        >
          {data?.username?.substring(0, 1).toUpperCase()}
        </Avatar>
        <br />
        <br />
        <Button
          type="primary"
          onClick={() => navigate("/user/change-pwd")}
          style={{
            width: "100%",
            marginBottom: "10px",
            fontSize: isMobile ? "14px" : "16px",
          }}
        >
          Change Password
        </Button>
        <Button
          type="primary"
          onClick={() => navigate("/user/profile-edit")}
          style={{
            width: "100%",
            marginBottom: "10px",
            fontSize: isMobile ? "14px" : "16px",
          }}
        >
          Edit Profil
        </Button>
      </div>

      {/* Right Section: User Details */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "500px",
          padding: isMobile ? "10px" : "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(33, 33, 33, 0.1)",
          marginTop: isMobile ? "20px" : "0", // Tambahkan margin atas untuk mobile
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "18px" : "24px",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          {data?.username}
        </h1>
        {data ? (
          <Table
            pagination={false}
            bordered
            dataSource={[
              { label: "Full Name", value: data.name },
              { label: "Email", value: data.email },
              { label: "Role", value: data.role_name },
              { label: "NIK", value: data.nik },
              { label: "Birthdate", value: data.birthdate },
            ]}
            columns={[
              {
                title: "Information",
                dataIndex: "label",
                key: "label",
                width: "40%",
              },
              {
                title: "Detail",
                dataIndex: "value",
                key: "value",
                width: "60%",
              },
            ]}
            style={{
              width: "100%",
              fontSize: isMobile ? "14px" : "16px", // Ukuran font tabel lebih kecil untuk mobile
            }}
          />
        ) : (
          <div>
            <Skeleton active paragraph={{ rows: 4 }} />
            <Button type="primary" block disabled>
              Loading..
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
